export default "__VITE_ASSET__AlD71xFO__"